import salesBudgetYearInputLayout from './salesBudgetYearInputLayout';

export default salesBudgetYearInputLayout;
